import { getTokenExpiryMs, refreshAuthToken } from '@/lib/auth';

/**
 * Browser-native attachment download via a same-origin anchor.
 *
 * Why not fetch→blob: that buffered the ENTIRE file in memory with zero
 * progress feedback and failed silently on slow connections. The anchor
 * hands the transfer to the browser's download manager (visible progress,
 * resilient on slow links, visible failure states).
 *
 * Caveat: an anchor navigation can't run the silent 401→refresh→retry
 * flow, so we proactively refresh the auth cookie when it is expired or
 * about to expire (< 2 min) before triggering the download.
 */
export async function nativeAuthedDownload(url: string, filename: string): Promise<void> {
  const msLeft = getTokenExpiryMs();
  if (msLeft === null || msLeft < 2 * 60 * 1000) {
    // Best-effort: if refresh fails the anchor still fires and the
    // browser surfaces the failed download instead of silence.
    await refreshAuthToken().catch(() => false);
  }
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
